import React from 'react';
import StringArrayInput from './Generic/StringArrayInput';
import { bindOnChange } from '../Functions/Helper/OnChange';
import { ExpandingTextarea } from './Generic/Input/FormControlInput';

const toValue = (d) => (d?.mcb_description || "");
const toObject = (mcb_description, i) => {
    return ({ ...(i || {}), mcb_description });
};
const toDisplay = (d) => (
    <span className="fw-normal">
        <strong className="fw-bolder">{d.mcb_responsibility}</strong> {d.mcb_description}
    </span>
);

const toKey = (d) => d?.mcb_responsibilityid;
const inputProps = ({ value, onChange, formContainerRef }) => {
    if (formContainerRef.current) {
        setTimeout(() => {
            const formContainerDOM = formContainerRef.current;
            if (!formContainerDOM) return;
            const submitButton = formContainerDOM.querySelector('button.submit-button');
            if (!submitButton) return;

            if (value?.mcb_responsibility && value?.mcb_description ) {
                submitButton.classList.add("anim-pulse");
            } else {
                submitButton.classList.remove("anim-pulse");
            }
        }, 10);
    }
    return ({
        type: "textarea",
        placeholder: "Additional Details...",
        maxCharacterCount: 250,
        preAddOn: {
            className: "pe-1",
            children: (
                <ExpandingTextarea
                    required
                    placeholder='Type Responsibility Here'
                    value={(value.mcb_responsibility) || ""}
                    className="fw-bolder mt-2 pb-1"
                    style={{
                        width: `100%`,
                        minWidth: "23ch",
                        outline: 0,
                        border: "0px none transparent",
                        borderBottom: "1px solid gray"
                    }}
                    rows={1}
                    maxCharacterCount={40}
                    onChange={(e) => {
                        onChange({ ...value, mcb_responsibility: e.target.value });
                    }}
                />
            )
        }
    });
};
const labelOverride = () => "Add Draft";
export function ResponsibilitiesInput({ value, onChange, required }) {
    const _onChange = React.useMemo(() => bindOnChange(onChange, "responsibilities"), [onChange]);
    
    return (
        <StringArrayInput
            required={required && !value?.responsibilities?.length}
            label={<strong>Key Responsibilities</strong>}
            values={value?.responsibilities || []}
            onChange={_onChange}
            defaultValue={{}}
            toValue={toValue}
            toObject={toObject}
            toDisplay={toDisplay}
            toKey={toKey}
            labelOverride={labelOverride}
            inputProps={inputProps} />
    );
}
